export const iconFontAwesomeChartsDiagramsBarsProgress = (
	<i className="fa-solid fa-bars-progress"></i>
);
